/**
 * © 2026 Madar.iq — All Rights Reserved.
 * This software is proprietary and confidential.
 */

(function () {
  "use strict";

  const userAgent = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const maxTouchPoints = navigator.maxTouchPoints || 0;

  const isDev =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    process.env.NODE_ENV === "development";

  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (platform === "MacIntel" && maxTouchPoints > 1);

  const isMobileSafari =
    /Safari/i.test(userAgent) &&
    !/CriOS|FxiOS|EdgiOS|OPiOS|Chrome|Android/i.test(userAgent);

  const skipAggressiveProtection = isIOS || isMobileSafari;

  if (isDev) return;

  document.addEventListener("contextmenu", function (e) {
    e.preventDefault();
    return false;
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "F12") {
      e.preventDefault();
      return false;
    }

    if (
      e.ctrlKey &&
      e.shiftKey &&
      (e.key === "I" || e.key === "i" || e.key === "J" || e.key === "j" || e.key === "C" || e.key === "c")
    ) {
      e.preventDefault();
      return false;
    }

    if (e.ctrlKey && (e.key === "U" || e.key === "u")) {
      e.preventDefault();
      return false;
    }

    if (e.ctrlKey && (e.key === "S" || e.key === "s")) {
      e.preventDefault();
      return false;
    }

    if (e.ctrlKey && (e.key === "A" || e.key === "a")) {
      e.preventDefault();
      return false;
    }
  });

  document.addEventListener("copy", function (e) {
    e.preventDefault();
    return false;
  });

  document.addEventListener("selectstart", function (e) {
    e.preventDefault();
    return false;
  });

  document.addEventListener("dragstart", function (e) {
    e.preventDefault();
    return false;
  });

  if (!skipAggressiveProtection) {
    const devToolsCheck = { isOpen: false };
    const threshold = 160;

    function onDevToolsOpen() {
      document.body.innerHTML = `
        <div style="
          display:flex;
          flex-direction:column;
          align-items:center;
          justify-content:center;
          height:100vh;
          background:#0f172a;
          color:#f8fafc;
          font-family:sans-serif;
          text-align:center;
          gap:16px;
        ">
          <div style="font-size:64px;">🔒</div>
          <h1 style="font-size:2rem;font-weight:700;color:#ef4444;">Access Denied</h1>
          <p style="color:#94a3b8;max-width:400px;">
            هذا البرنامج محمي بموجب قوانين الملكية الفكرية.<br/>
            <strong style="color:#f1f5f9;">© 2026 Madar.iq — All Rights Reserved</strong>
          </p>
        </div>
      `;
    }

    function detectDevTools() {
      const widthDiff = window.outerWidth - window.innerWidth > threshold;
      const heightDiff = window.outerHeight - window.innerHeight > threshold;

      if (widthDiff || heightDiff) {
        if (!devToolsCheck.isOpen) {
          devToolsCheck.isOpen = true;
          onDevToolsOpen();
        }
      } else {
        devToolsCheck.isOpen = false;
      }
    }

    setInterval(detectDevTools, 1000);

    setInterval(function () {
      (function () {
        return false;
      })
        .constructor("debugger")
        .call();
    }, 10000);
  }

  const noop = function () {};
  const protectionMsg = [
    "%cSTOP! هذا التطبيق محمي",
    "color:#ef4444;font-size:24px;font-weight:bold;",
  ];
  const infoMsg = [
    "%c© 2026 Madar.iq — جميع الحقوق محفوظة",
    "color:#f59e0b;font-size:13px;",
  ];

  setTimeout(function () {
    if (typeof console !== "undefined") {
      try {
        console.log(...protectionMsg);
        console.log(...infoMsg);

        const originalError = console.error;
        console.log = noop;
        console.warn = noop;
        console.info = noop;
        console.debug = noop;
        console.dir = noop;
        console.table = noop;

        console.error = function (...args) {
          if (args[0] && typeof args[0] === "string" && args[0].includes("[Madar.iq]")) {
            originalError.apply(console, args);
          }
        };
      } catch (e) {
        // ignore
      }
    }
  }, 500);

  try {
    const stamp = btoa(
      JSON.stringify({
        product: "Madar.iq",
        license: "PROPRIETARY",
        year: 2026,
        warning: "Unauthorized use prohibited",
      })
    );
    window.localStorage.setItem("_madar_protected", stamp);
  } catch (e) {
    // ignore
  }

  if (window.self !== window.top) {
    try {
      window.top.location = window.self.location;
    } catch (e) {
      // ignore cross-origin issues
    }
  }
})();
